import { defineStore } from 'pinia';
import type {} from 'pinia-plugin-persistedstate';

interface LanguageNoticeState {
  acknowledged: boolean;
}

const createInitialState = (): LanguageNoticeState => ({
  acknowledged: false,
});

export const useLanguageNoticeStore = defineStore('textModeLanguageNotice', {
  state: createInitialState,

  actions: {
    acknowledge(): void {
      this.acknowledged = true;
    },
  },

  persist: {
    storage: sessionStorage,
    pick: ['acknowledged'],
  },
});
